<sd-ymap
  [isClustered]="true"
  [clusterOptions]="shopClusterOptions$ | async"
  [geoObjects]="shopGeoObjects$ | async"
  (created)="onMapCreated($event)"
></sd-ymap>

<div class="map-zoom-controls">
  <button class="btn-icon zoom-button zoom-in" title="+" (click)="onMapZoom('IN')">
    <sd-icon [type]="iconType.PLUS" class="icon-size-s icon-size-md-m"></sd-icon>
  </button>
  <button class="btn-icon zoom-button zoom-out" title="-" (click)="onMapZoom('OUT')">
    <sd-icon [type]="iconType.MINUS" class="icon-size-s icon-size-md-m"></sd-icon>
  </button>
</div>
